import React from 'react'

const About = () => {
  return (
    <div>
      <h1 className='text-center m-5'>About</h1>
    </div>
  )
}

export default About